<template>
  <section class="not-authenticated">
    <span class="not-authenticated__padding" />
    <div class="not-authenticated__content">
      <router-view />
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotAuthenticatedLayout',
  beforeMount() {
    if (this.$session.getSession('pleez-token')) {
      this.$router.push('/dashboard');
    }
  },
};
</script>

<style lang="scss">
.not-authenticated {
  display: flex;
  justify-content: center;

  height: 100%;

  &__padding {
    display: none;

    height: 100%;
    width: 45%;

    background-color: var(--brand-secondary);
  }
  &__content {
    flex: 1;

    height: 100%;
    padding: var(--spacing-xl) var(--spacing-s);

    box-sizing: border-box;
  }

  @include breakpoint-from('tablet') {
    align-items: center;
  }
  @include breakpoint-from('smallDesktop') {
    justify-content: unset;

    &__padding {
      display: block;
    }
  }
}
</style>
